"use client";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

function Logo({ path, isRevert }: { path: string; isRevert?: boolean }) {
  const router = useRouter();
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (isRevert) {
    return (
      <Image
        onClick={() => router.push(path)}
        src="/revert-logo.png"
        alt="Author Flows Logo"
        width={100}
        height={100}
      />
    );
  }

  // After mount, use the white logo in dark mode
  const src =
    mounted && resolvedTheme === "dark" ? "/revert-logo.png" : "/logo.svg";

  return (
    <Image
      onClick={() => router.push(path)}
      src={src}
      alt="Author Flows Logo"
      width={100}
      height={100}
      priority
    />
  );
}

export default Logo;
